var StateService = /** @class */ (function () {
    function StateService(api) {
        var _this = this;
        this.fetchStates = function (app) { return _this.API.get("/state/".concat(app)); };
        this.createState = function (state) { return _this.API.post('/state', state); };
        this.updateState = function (state) {
            return _this.API.patch("/state/".concat(state === null || state === void 0 ? void 0 : state.app, "/").concat(state === null || state === void 0 ? void 0 : state.id), state);
        };
        this.deleteState = function (app, state) { return _this.API.delete("/state/".concat(app, "/").concat(state)); };
        this.API = api;
    }
    return StateService;
}());
export { StateService };
